import {
  CreateOrUpdateTransitOperationRequestDeclarationTypeEnum,
  CreateOrUpdateTransitOperationRequestSecurityEnum,
} from 'api/models'
import {
  TYPE_OF_PERSON_PREFIX,
} from 'shared/ncts/common/classifier-util'
import { ISelectOption } from 'types/IClassifier'
import { DEFAULT_TRANSIT_DECLARATION_TYPES } from 'config'

export const DECLARATION_TYPE_OPTIONS: ISelectOption[] = [{
  value: CreateOrUpdateTransitOperationRequestDeclarationTypeEnum.T1,
  label: 'T1 - Goods not having the customs status of Union goods, which are placed under the common transit procedure.',
},
{
  value: CreateOrUpdateTransitOperationRequestDeclarationTypeEnum.T2,
  label: 'T2 - Goods having the customs status of Union goods, which are placed under the common transit procedure',
},
{
  value: CreateOrUpdateTransitOperationRequestDeclarationTypeEnum.T2F,
  label: 'T2F - Goods required to move under the internal Union transit procedure, in accordance with Article 188 of Delegated Regulation (EU) 2015/2446',
},
{
  value: CreateOrUpdateTransitOperationRequestDeclarationTypeEnum.ENS,
  label: 'ENS - Entry Summary Declaration submitted to the ICS2 system for all goods transported to or through the EU prior to their arrival or loading',
},
]

export const TRANSIT_DECLARATION_TYPE_OPTIONS: ISelectOption[] = DECLARATION_TYPE_OPTIONS
  .filter((option) => DEFAULT_TRANSIT_DECLARATION_TYPES.includes(option.value))

export const ADDITIONAL_DECLARATION_TYPE_OPTIONS: ISelectOption[] = [{
  value: 'A',
  label: 'A - for a standard customs declaration (under Article 162 of the Code)',
},
{
  value: 'D',
  label: 'D - For lodging a standard customs declaration (such as referred to under code A) in accordance with Article 171 of the Code.',
},
]

export const SECURITY_OPTIONS: ISelectOption[] = [{
  value: CreateOrUpdateTransitOperationRequestSecurityEnum.S0,
  label: '0 - Not used for safety and security purposes',
},
{
  value: CreateOrUpdateTransitOperationRequestSecurityEnum.S1,
  label: '1 - ENS',
},
{
  value: CreateOrUpdateTransitOperationRequestSecurityEnum.S2,
  label: '2 - EXS',
},
{
  value: CreateOrUpdateTransitOperationRequestSecurityEnum.S3,
  label: '3 - ENS & EXS',
},
]

export const SPECIFIC_CIRCUMSTANCE_INDICATOR_OPTIONS: ISelectOption[] = [{
  value: 'F50',
  label: 'F50 - Road mode of transport',
},
{
  value: 'F51',
  label: 'F51 - Rail mode of transport',
},
{
  value: 'A20',
  label: 'A20 - Express consignments in the context of exit summary declarations',
},
{
  value: 'F34',
  label: 'F34 - Express consignments – Complete dataset – Road mode of transport',
}]

export const ADDITIONAL_SUPPLY_CHAIN_ACTOR_ROLE_OPTIONS: ISelectOption[] = [{
  value: 'CS',
  label: 'CS - Consolidator',
},
{
  value: 'FW',
  label: 'FW - Freight Forwarder',
},
{
  value: 'MF',
  label: 'MF - Manufacturer',
},
{
  value: 'WH',
  label: 'WH - Warehouse Keeper',
},
{
  value: 'CE',
  label: 'CE - Consignee',
},
{
  value: 'CO',
  label: 'CO - Consignor',
},
{
  value: 'CR',
  label: 'CR - Carrier',
},
]

export const TYPE_OF_PERSON_OPTIONS: ISelectOption[] = [{
  value: '1',
  label: '1 - Natural person',
},
{
  value: '2',
  label: '2 - Legal person',
},
{
  value: '3',
  label: '3 - Association of persons',
},
].map((option) => {
  const o = option
  o.value = TYPE_OF_PERSON_PREFIX + option.value
  return o
})
